import React, {useContext, useMemo} from 'react';

const ModalContext = React.createContext({isInModal: false, modalRef: null});

/**
 * A React Higher Order Component (HOC) used to communicate down the tree if the children are
 * supposed to be in a modal. In particular, as this is used in the CollapsibleSidebar component,
 * we also pass a reference to the footer of the modal, as it is used to set the sidebar height.
 */
export function WithModalContext({isInModal, modalRef, children}) {
    const context = useMemo(
        () => ({
            isInModal: isInModal ?? false,
            modalRef: modalRef,
        }),
        [isInModal, modalRef],
    );

    return <ModalContext.Provider value={context}>{children}</ModalContext.Provider>;
}

export const useModalContext = () => useContext(ModalContext);
